<div data-test-id="modal-confirm" class="modal-window">
  <div class="modal-header">
    <h4 class="modal-title" data-test-id="modal-title">
      {{ dialog.title | translate }}
    </h4>
    <button
      type="button"
      class="unstyled-button"
      [attr.id]="'modal-btn-close-cross'"
      aria-label="Close"
      data-test-id="modal-btn-dismiss"
      (click)="onDismiss()"
    >
      <svg-icon src="assets/icons/icon-cross.svg" class="icon-cross"></svg-icon>
    </button>
  </div>
  <div class="modal-body text-break" data-test-id="wrap-confirm">
    <p class="mb-0" [innerHTML]="dialog.description | translate" data-test-id="modal-description"></p>
  </div>
  <div class="modal-footer" data-test-id="modal-footer">
    <button
      *ngFor="let button of dialog.buttons; index as i"
      [attr.type]="button.type || 'button'"
      class="btn"
      appLongOperation
      [ngClass]="button.class"
      (click)="actionsHandler(button.action)"
      [attr.data-test-id]="'modal-btn-' + i"
      [attr.id]="button.action === 'confirmAction' ? 'modal-btn-confirmAction' : 'modal-btn-close'"
    >
      {{ button.text | translate }}
    </button>
  </div>
</div>
